(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/login-iam/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/login-iam/assets/javascripts/prescript.js');

'use strict';

svs.login_iam = svs.login_iam || {};
svs.login_iam.constants = svs.login_iam.constants || {};
svs.login_iam.utils = svs.login_iam.utils || {};
svs.login_iam.utils.iamIframeEidAppHandler = svs.login_iam.utils.iamIframeEidAppHandler || {};
svs.login_iam.utils.Dialogs = svs.login_iam.utils.Dialogs || {};

 })(window);